import { Component, OnInit, HostBinding } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.scss']
})
export class QuickSearchComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  searchForm: UntypedFormGroup;

  constructor(
    private route: ActivatedRoute,
    private catalogConfigService: CatalogConfigService,
    private formBuilder: UntypedFormBuilder,
    private router: Router
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName} exported`;
    this.searchForm = this.formBuilder.group({
      searchText: [null]
    });
  }

  ngOnInit() {}

  execSearch() {
    if (!this.searchForm.value.searchText) return;
    const tmpParam = { text: this.searchForm.value.searchText };
    this.searchForm.reset();
    this.router.navigate([`/${this.catalogConfigService.routingBaseUri}/searchresult`], {
      queryParams: tmpParam
    });
  }
}
